export default function PHP_deg2rad() {
  return (
    <div>
      <h1>PHP_deg2rad</h1>
    </div>
  );
}
